import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var LogoAiIcon = function LogoAiIcon(_a) {
  var className = _a.className,
    otherProps = __rest(_a, ["className"]);
  return jsx("svg", Object.assign({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "LogoAiIcon",
    role: "img",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "none",
    className: classNames('cogs-icon', className)
  }, otherProps, {
    children: jsx("path", {
      fill: "currentColor",
      d: "M7 14c.326 0 .593-.24.639-.58.448-3.022.86-3.443 3.768-3.773A.67.67 0 0 0 12 9a.67.67 0 0 0-.589-.652c-2.89-.402-3.247-.755-3.772-3.773C7.579 4.24 7.322 4 7 4c-.33 0-.593.24-.648.58-.439 3.017-.851 3.438-3.754 3.768C2.254 8.394 2 8.665 2 9c0 .326.245.597.589.647 2.894.412 3.247.76 3.763 3.778.068.34.331.575.648.575M12 6c.13 0 .237-.096.255-.232.18-1.209.345-1.377 1.508-1.51A.27.27 0 0 0 14 4a.27.27 0 0 0-.236-.26c-1.155-.162-1.298-.303-1.509-1.51C12.232 2.096 12.13 2 12 2a.263.263 0 0 0-.26.232c-.175 1.207-.34 1.375-1.5 1.507A.266.266 0 0 0 10 4c0 .13.098.239.236.259 1.157.165 1.298.304 1.505 1.511.027.136.132.23.259.23"
    })
  }));
};

export { LogoAiIcon };
